import { Variant } from '~/src/components/generic/IconButton/types'

export const classVariants: { [key in Variant]: string } = {
  primary: 'bg-blue-500 hover:bg-blue-400',
  secondary: 'border border-gray-300 bg-gray-100 hover:bg-gray-300 rounded',
  outlined:
    'bg-white hover:bg-gray-100 border border-blue-600 shadow hover:shadow-md rounded active:border-blue-200 h-8 w-8 text-blue-600',
  ghost:
    'bg-transparent hover:bg-gray-100 rounded active:ring-gray-300 active:ring-1 p-0.5',
}

export const classVariantsV2: { [key in Variant]: string } = {
  primary:
    'shadow hover:shadow-md bg-gray-700 border border-gray-700 text-white hover:bg-gray-900 hover:border-gray-900 active:border-gray-300 disabled:text-gray-50 disabled:cursor-not-allowed disabled:bg-gray-400 disabled:border-none rounded size-8',
  secondary: 'border border-gray-300 bg-gray-100 hover:bg-gray-300 rounded',
  outlined:
    'bg-white hover:bg-gray-100 border border-gray-700 hover:border-gray-900 shadow hover:shadow-md rounded active:border-gray-300 h-8 w-8 text-gray-900 shadow',
  ghost:
    'bg-transparent hover:bg-gray-100 rounded active:ring-gray-300 active:ring-1 p-0.5',
}

export const disabledClassVariants: { [key in Variant]: string } = {
  primary: 'bg-gray-400 pointer-events-none',
  secondary: 'border border-gray-300 bg-gray-100 pointer-events-none text-gray-400',
  outlined:
    'bg-transparent border-gray-300 shadow-none pointer-events-none text-gray-300',
  ghost: 'bg-transparent pointer-events-none text-gray-400',
}
